module.exports = __webpack_public_path__ + "static/media/wheels_front_tire_depth_picture.895258ec.png";